var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"form-control",class:{ 'is-invalid': _vm.isFileError },attrs:{"id":"formFile","type":"file","accept":"image/*"},on:{"change":_vm.onFileChange}}),(_vm.isFileError)?_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.validationText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }